import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Championships, Players, Teams } from 'modules/main/domain/types/types';
import { createFetchChampionshipsReducer } from 'modules/main/store/main-page/reducers';

export interface MainPageSliceState {
  tournamentId: number | null;

  totalChampionships: number;
  championships: Championships;
  players: Players;
  teams: Teams;

  status: {
    loading: boolean;
    refreshing: boolean;
    loaded: boolean;
    error: string | null;
  };
}

const initialState: MainPageSliceState = {
  tournamentId: null,

  totalChampionships: 0,
  championships: {
    stared: 0,
    ended: 0,
    preparing: 0,
  },
  players: {
    total: 0,
    declared: 0,
    bestScorers: [],
  },
  teams: {
    total: 0,
    declared: 0,
    popular: [],
  },

  status: {
    loading: false,
    refreshing: false,
    loaded: false,
    error: null,
  },
};

export const mainPageSlice = createSlice({
  name: 'mainPage',
  initialState,
  reducers: {
    setTournamentId: (state, action: PayloadAction<{ tournamentId: number | null }>) => {
      state.tournamentId = action.payload.tournamentId;
    },
  },
  extraReducers: (builder) => {
    createFetchChampionshipsReducer(builder);
  },
});

export const { setTournamentId } = mainPageSlice.actions;

export default mainPageSlice.reducer;
